import React from 'react'
import LowerProductCarouselOne from './LowerProductCarouselOne'

const LowerProductCarouselMain = () => {
    return (
        <>
            <section className="main-wrap caro-first" style={{padding:"0px"}}>
                <div className="container-fluid">
                    <h2 className="title1 lower-pro">Electronics</h2>
                  <LowerProductCarouselOne/>
                </div>
            </section>

        </>
    )
}

export default LowerProductCarouselMain
